export default class FeatureManager {
    constructor(featureFlags) {
        this.featureFlags = featureFlags;
    }

    isEnabled(flagName) {
        return this.featureFlags && this.featureFlags[flagName];
    }
}